import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {FormDefinitionFormSummaryModel} from '../../../../form/definition/form/api/entity/formDefinitionFormSummary.model';
import {CommunicationConfigurationModel} from '../../../../communication/configuration/api/model/communicationConfiguration.model';

export class OnlineFormFormDefinitionSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    welcomeText: string;
    sendingNbDaysBeforeDeadline: number;
    title: string;
    formDefinition: FormDefinitionFormSummaryModel;
    communicationConfiguration: CommunicationConfigurationModel;
}
